<template>
  <div>
    <div class="buttons">
      <router-link to="/cart" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </router-link>
      <span>決済方法選択</span>
    </div>
    <div>
      <p>決済方法を選択してください。</p>
      <div class="payments">
        <router-link :to="{path:'./confirm/yahoo'}"><img src="../../assets/img/image3.png" height="100" width="300"/></router-link><br>
        <router-link :to="{path:'./confirm/mercari'}"><img src="../../assets/img/image5.png" height="100" width="300"/></router-link><br>
        <router-link :to="{path:'./confirm/rakuma'}"><img src="../../assets/img/image4.png" height="100" width="300"/></router-link><br>
      </div>
      <p>上記以外で、直接決済する。</p>
      <div class="payments">
        <router-link :to="{path:'./confirm/base'}"><img src="../../assets/img/image7.png" height="100" width="300"/></router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'Payment',
    components: {
    },
    data () {
      return {
      };
    },
    created () {
    },
    computed: {
      cart () {
        return this.$store.state.cart;
      }
    },
    filters: {
      money (val) {
        return '¥' + val.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,') + '〜';
      }
    }
  };
</script>

<style scoped lang="scss">
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
  }
  .payments {
    text-align:center;
  }
</style>
